import React from "react";
import PropTypes from 'prop-types';

export default class Navigation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpenNavigation: false
        };

        this.checkIsMobile = this.checkIsMobile.bind(this);

        this.isMobile = false;
    }

    componentDidMount() {
        this.checkIsMobile();

        if (window.attachEvent) {
            window.attachEvent('onresize', this.checkIsMobile);
        } else {
            window.addEventListener('resize', this.checkIsMobile);
        }
    }

    checkIsMobile() {
        let checkInNavigationData = [
            /Mobile/i,
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i
        ].some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });

        this.isMobile = ((768 >= document.documentElement.offsetWidth) || checkInNavigationData);
    }

    change = (event, nav) => {
        if (event) {
            if (event.preventDefault)
                event.preventDefault();

            if (event.stopPropagation)
                event.stopPropagation();
        }

        const {props: {onClick}, state: {isOpenNavigation}, isMobile} = this;

        if (isMobile && !isOpenNavigation) {
            this.setState({
                isOpenNavigation: true
            })

            return;
        }

        this.setState({isOpenNavigation: false});
        onClick(nav);
    }

    render() {
        const {name, className, links, active, onChange} = this.props;
        const {state: {isOpenNavigation}} = this;

        //{value, href, label, slug, singular, className: liClassName}
        return links ? links.map((link) => <button key={`navigation-${link.value}`}
                                                   onClick={(event) => this.change(event, link)}
                                                   className={`${link.value ?? ''} ${isOpenNavigation ? 'extend' : ''} ${active === link.value ? 'active' : ''}`}>{link.label}
        </button>) : <></>;
    }
}

Navigation.propTypes = {
    name: PropTypes.string,
    links: PropTypes.array.isRequired,
    className: PropTypes.string,
    active: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.array]),
    onClick: PropTypes.func
}

Navigation.defaultProps = {
    name: '',
    links: [],
    className: '',
    active: null,
    onClick: () => {
    }
}